import { render, staticRenderFns } from "./websayfalari.vue?vue&type=template&id=a1a702e0&"
import script from "./websayfalari.vue?vue&type=script&lang=js&"
export * from "./websayfalari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports